// extracted by mini-css-extract-plugin
export default {"suggested_wrap":"suggested_suggested_wrap__A0RLR","suggested_inner":"suggested_suggested_inner__6MN9w","suggested_list":"suggested_suggested_list__nF1J2"};